module.exports = __webpack_public_path__ + "img/work-time-pana.679d285d.svg";